/** Store del tema actual con persistencia en localStorage. */

import { create } from 'zustand';
import { applyTheme, DEFAULT_THEME_ID, getThemeById } from './themes';

const STORAGE_KEY = 'alpha.theme';

interface ThemeState {
  themeId: string;
  setTheme: (id: string) => void;
  /** Llamar al boot de la app para inicializar desde localStorage. */
  hydrate: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  themeId: DEFAULT_THEME_ID,
  setTheme: (id: string) => {
    const t = getThemeById(id);
    applyTheme(t);
    try {
      localStorage.setItem(STORAGE_KEY, t.id);
    } catch {
      // ignorar (modo privado o storage lleno)
    }
    set({ themeId: t.id });
  },
  hydrate: () => {
    let saved: string | null = null;
    try {
      saved = localStorage.getItem(STORAGE_KEY);
    } catch {
      saved = null;
    }
    const t = getThemeById(saved || DEFAULT_THEME_ID);
    applyTheme(t);
    set({ themeId: t.id });
  },
}));
